import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { from, map, catchError, of } from 'rxjs';
import { fetchAuthSession } from 'aws-amplify/auth';

export const authGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const loginTree = router.createUrlTree(['/auth'], {
    queryParams: { returnUrl: state.url },
  });

  // Read Amplify's live session here; AuthService.currentUserValue is not rehydrated on reload.
  return from(fetchAuthSession()).pipe(
    map((session) => (session.tokens?.accessToken ? true : loginTree)),
    catchError(() => of(loginTree))
  );
};
